// extracted by mini-css-extract-plugin
export default {"footerWithSubtext":"shipping-address-form__footerWithSubtext__WWzn_","subtext":"shipping-address-form__subtext__IGxoP"};